PJQ.models.workAreas = {};
PJQ.models.workAreas.WorkArea = PJQ.models.BaseModel.extend({
	idAttribute: 'workAreaId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'contacts',
				value: this.get('contactId')
			},
			{
				endpoint: 'workareas',
				value: this.id
			}
		]);
	},
	isStateWorkArea: function () {
		return _.size(this.get('state')) > 0 && !this.isCountyWorkArea();
	},
	isCountyWorkArea: function () {
		return _.size(this.get('county')) > 0;
	}
});

PJQ.models.workAreas.ContactWorkArea = PJQ.models.workAreas.WorkArea.extend({
	idAttribute: 'contactWorkAreaId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'contacts',
				value: this.get('contactId')
			},
			{
				endpoint: 'workareas',
				value: this.id > 0 ? this.get('workAreaId') : null
			}
		]);
	}
});

PJQ.collections.workAreas = {};
PJQ.collections.workAreas.WorkAreas = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.workAreas.WorkArea,
	endpoint: function () {
		let queryParams = [];
		if (_.size(this.options.country) > 0) {
			queryParams.push({
				parameter: 'country',
				value: this.options.country
			});
		}
		if (_.size(this.options.state) > 0) {
			queryParams.push({
				parameter: 'state',
				value: this.options.state
			});
		}
		if (_.size(this.options.zip) > 0) {
			queryParams.push({
				parameter: 'zip',
				value: this.options.zip
			});

		}
		if (this.options.radius > 0) {
			queryParams.push({
				parameter: 'radius',
				value: this.options.radius
			});
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'workAreas'
			}
		], queryParams);
	},
	getExistingWorkArea: function (workArea) {
		return _.find(this.models, function (existingWorkArea) {
			//If the county region is already added, or the full state for the county is added, filter the work area out
			return !existingWorkArea.get('isDeleted') && (existingWorkArea.get('workAreaId') === workArea.get('workAreaId') || (existingWorkArea.get('state') === workArea.get('state') && existingWorkArea.isStateWorkArea()));
		})
	}
});

PJQ.collections.workAreas.ContactWorkAreas = PJQ.collections.workAreas.WorkAreas.extend({
	model: PJQ.models.workAreas.ContactWorkArea,
	endpoint: function () {
		let queryParams = [];
		if (_.size(this.options.zip) > 0) {
			queryParams.push({
				parameter: 'zip',
				value: this.options.zip
			});

		}
		if (this.options.radius > 0) {
			queryParams.push({
				parameter: 'radius',
				value: this.options.radius
			});
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'contacts',
				value: this.options.contactId
			},
			{
				endpoint: 'workAreas'
			}
		], queryParams);
	}
});

PJQ.views.workAreas = {};
PJQ.views.workAreas.WorkAreaMap = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Work-Area-Map-Inline'),
		isInline: true,
		isStacked: false,
		isEdit: false,
		isMapOnly: false,
		isSync: true,
		defaultRadius: 50,
		mapZoom: 4,
		mapCenter: null,
		onChange: _.noop,
		onDelete: _.noop,
		onFetch: _.noop
	},
	events: {
		'keyup .work-area-zip': 'workAreaZipInputChanged',
		'keyup .work-area-radius': 'workAreaRadiusInputChanged',
		'click .add-work-area-state-county': 'addWorkAreaByStateCounty',
		'click .add-work-area-zip': 'addWorkAreasByZipRadius',
		'click .delete-work-area': 'deleteWorkAreaEvent',
		'click .delete-all-work-areas': 'deleteAllWorkAreas',
	},
	beforeFirstRender: function () {
		this.options.mapCenter = typeof google === 'object' ? new google.maps.LatLng(38.6159, -100.7456) : null;

		if (!this.options.isInline)
			this.options.template = new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Work-Area-Map');

		if (!(this.options.contactId > 0) && PJQ.app.session.contact != null) {
			this.options.contactId = PJQ.app.session.contact.id;
		}

		if (this.collection == null) {
			this.collection = new PJQ.collections.workAreas.ContactWorkAreas([], {
				contactId: this.options.contactId
			});
		}

		this.listenTo(this.collection, 'update fetch', _.bind(function () {
			this.renderDeleteAllButtons();
		}, this));

		if (!this.options.isFetched && this.collection.options.contactId > 0) {
			this.collection.fetch({
				success: _.bind(function () {
					this.options.isFetched = true;
					this.render();

					if (typeof this.options.onFetch === 'function') {
						this.options.onFetch();
					}
				}, this)
			});
		}
		else {
			this.render();
		}
		return false;
	},
	beforeRender: function () {
		this.renderData = {
			options: this.options
		};
	},
	afterRender: function () {
		this.renderUI();
	},
	renderUI: function () {
		if (this.options.isEdit) {
			this.renderInputs();
		}
		this.renderDataTables();
		this.renderDeleteAllButtons();
		this.renderMap();
	},
	renderInputs: function () {
		this.radiusSlider = new PJQ.Slider(this.$('.work-area-radius-slider'), {
			ticks: [1, 50, 100, 150, 200, 250, 300],
			ticks_labels: [1, 50, 100, 150, 200, 250, 300],
			value: this.options.defaultRadius,
			onChange: _.bind(function (obj) {
				this.setWorkAreaRadius(obj.newValue);
			}, this)
		});

		this.countryPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.work-area-country'),
			defaultValue: PJQ.constants.countries[0].toUpperCase(),
			onChange: _.bind(function (value) {
				this.populateStateSelect();
				if (value.toLowerCase() === 'ca') {
					this.$('.work-area-county').closest('div.input-group').addClass('invisible');
				}
				else {
					this.$('.work-area-county').closest('div.input-group').removeClass('invisible');
				}
				this.workAreaStateCountyInputChanged();
			}, this)
		});

		this.statePicker = new PJQ.inputs.Selectpicker({
			el: this.$('.work-area-state'),
			noneSelectedText: 'State',
			hideDisabled: false,
			isMultiple: true,
			onChange: _.bind(function () {
				this.populateCountySelect();
				this.workAreaStateCountyInputChanged();
			}, this)
		});

		this.countyPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.work-area-county'),
			noneSelectedText: 'County',
			isIntChoices: true,
			isMultiple: true,
			hideDisabled: false,
			onChange: _.bind(function () {
				this.workAreaStateCountyInputChanged();
			}, this)
		});

		this.populateStateSelect();
	},
	getStates: function (country, callback) {
		if (this.states == null) {
			this.states = [];
		}

		if (_.size(country) > 0 && this.states[country] == null) {
			let workAreas = new PJQ.collections.workAreas.WorkAreas([], {
				country: country
			});
			workAreas.fetch({
				success: _.bind(function () {
					this.states[country] = workAreas;
					callback(this.states[country]);
				}, this)
			});
		}
		else {
			callback(this.states[country]);
		}
	},
	populateStateSelect: function () {
		let country = this.countryPicker.getValue();
		this.$('select.work-area-state').empty();
		this.$('select.work-area-state').append('<option value="" disabled>State</option>');
		if (_.size(country) > 0) {
			this.getStates(country, _.bind(function (states) {
				_.each(states.models, function (workArea) {
					this.$('select.work-area-state').append('<option value="' + workArea.get('workAreaId').toString() + '" ' + (_.find(this.collection.models, function (existingWorkArea) {
						return existingWorkArea.get('isDeleted') !== true && existingWorkArea.get('workAreaId') === workArea.get('workAreaId');
					}) != null ? 'disabled' : '') + '>' + workArea.get('state') + '</option>');
				}, this);
				this.statePicker.refresh();
			}, this));
		}
		else {
			this.statePicker.refresh();
		}
		this.workAreaStateCountyInputChanged();
	},
	getCounties: function (country, state, callback) {
		if (this.counties == null) {
			this.counties = [];
		}

		if (_.size(country) > 0 && _.size(state) > 0 && this.counties[state] == null) {
			let workAreas = new PJQ.collections.workAreas.WorkAreas([], {
				country: country,
				state: state
			});
			workAreas.fetch({
				success: _.bind(function () {
					this.counties[state] = workAreas;
					callback(this.counties[state]);
				}, this)
			});
		}
		else {
			callback(this.counties[state]);
		}
	},
	populateCountySelect: function () {
		let country = this.countryPicker.getValue(),
			stateVal = this.statePicker.getValue(),
			stateWorkArea = _.size(country) > 0 && _.size(stateVal) === 1 ? this.states[country].get(stateVal[0]) : null;
		this.getCounties(country, stateWorkArea != null ? stateWorkArea.get('state') : null, _.bind(function (counties) {
			this.$('select.work-area-county').empty();
			this.$('select.work-area-county').append('<option value="" disabled>County</option>');
			if (counties != null) {
				_.each(counties.models, function (workArea) {
					this.$('select.work-area-county').append('<option value="' + workArea.get('workAreaId').toString() + '" ' + (_.find(this.collection.models, function (existingWorkArea) {
						return existingWorkArea.get('isDeleted') !== true && existingWorkArea.get('workAreaId') === workArea.get('workAreaId');
					}) != null ? 'disabled' : '') + '>' + workArea.get('county') + '</option>');
				}, this);
			}
			this.countyPicker.refresh();
		}, this));
		this.workAreaStateCountyInputChanged();
	},
	renderMap: function () {
		this.map = new PJQ.maps.GoogleMap(this.$('.work-area-map'), {
			zoom: this.options.mapZoom,
			center: this.options.mapCenter
		});
		this.renderMapLayers();
		this.refresh();
	},
	renderDataTables: function () {
		if (this.workAreaDataTable)
			this.workAreaDataTable.removeAllRows();

		//Go through each work area and make sure there aren't any county regions showing up where there is already a full state region
		//We don't want to delete the county regions, because they may be related to a public contact
		this.collection.models = _.filter(this.collection.models, function (model) {
			return !model.get('isDeleted') && (_.size(model.get('county')) === 0 || (_.find(this.collection.models, function (subModel) {
				return model.id !== subModel.id && model.get('state').toLowerCase() === subModel.get('state').toLowerCase() && _.size(subModel.get('county')) === 0;
			}) == null));
		}, this);

		let columns;
		if (this.options.isEdit) {
			columns = [
				{"data": "attributes.country", "title": "Country"},
				{"data": "attributes.state", "title": "State"},
				{"data": "attributes.county", "title": "County"},
				{
					"title": '<button type="button" class="btn btn-danger delete-all-work-areas m-0a"><i class="fal fa-trash"></i></button>',
					"defaultContent": '<button type="button" class="btn btn-danger delete-work-area m-0a"><i class="fal fa-trash"></i></button>',
					"orderable": false
				}
			];
		}
		else {
			columns = [
				{"data": "attributes.country", "title": "Country"},
				{"data": "attributes.state", "title": "State"},
				{"data": "attributes.county", "title": "County"}
			];
		}
		this.workAreaDataTable = new PJQ.views.dataTables.DataTable({
			el: this.$('.work-area-data-table'),
			data: _.sortBy(_.filter(this.collection.models, _.bind(function (model) {
				return model.get('state') && model.get('state').length > 0;
			}, this)), function (model) {
				return model.get('state');
			}),
			language: {
				emptyTable: "No work areas added",
				zeroRecords: "No work areas match the search criteria"

			},
			rowId: "cid",
			deferRender: true,
			columns: columns,
			dom: '<"top"<"clear">p>rt<"bottom"p<"clear">>'
		});
	},
	renderMapLayers: function () {
		this.renderStateLayers();
		this.renderCountyLayers();
	},
	renderStateLayers: function () {
		let states = _.map(_.filter(this.collection.models, function (workArea) {
			return !workArea.get('isDeleted') && workArea.isStateWorkArea()
		}), function (workArea) {
			return workArea.get('state');
		});
		if (this.stateLayerGuid) {
			this.map.removeMapObject(this.stateLayerGuid);
			this.stateLayerGuid = null;
		}
		if (_.size(states) > 0) {
			this.stateLayerGuid = this.map.addKMLStatesLayer(states);
		}
	},
	renderCountyLayers: function () {
		let countyIds = _.map(_.filter(this.collection.models, function (workArea) {
			return !workArea.get('isDeleted') && workArea.isCountyWorkArea()
		}), function (workArea) {
			return workArea.get('workAreaId');
		});
		if (this.countyLayerGuid) {
			this.map.removeMapObject(this.countyLayerGuid);
			this.countyLayerGuid = null;
		}
		if (_.size(countyIds) > 0) {
			this.countyLayerGuid = this.map.addKMLCountiesLayer(countyIds);
		}
	},
	reCenter: function () {
		if (this.map) {
			this.map.setCenter(this.options.mapCenter);
		}
	},
	refresh: function () {
		if (this.map) {
			this.map.resize();
		}
		if (this.radiusSlider) {
			this.radiusSlider.refresh();
		}
	},
	workAreaRadiusInputChanged: function () {
		this.setWorkAreaRadius(parseInt(this.$('.work-area-radius').val()));
	},
	setWorkAreaRadius: function (radius) {
		if (isNaN(radius) || radius < 1)
			radius = 1;
		else if (radius > 300)
			radius = 300;
		this.radiusSlider.setValue(radius);
		//don't set the radius input yet if the length of the value is 0 in case the user is trying to clear the input to enter a new value
		if (this.$('.work-area-radius').val().length > 0)
			this.$('.work-area-radius').val(radius);
	},
	workAreaZipInputChanged: function () {
		this.$('.add-work-area-zip').prop('disabled', !PJQ.helpers.validators.validateZip(this.$('.work-area-zip').val()))
	},
	workAreaStateCountyInputChanged: function () {
		let country = this.countryPicker.getValue(),
			stateWorkAreaId = this.statePicker.getValue(),
			countyWorkAreaId = this.countyPicker.getValue();

		if (_.size(country) > 0) {
			this.statePicker.enable();
		}
		else {
			this.statePicker.disable();
		}
		if (stateWorkAreaId > 0) {
			this.countyPicker.enable();
		}
		else {
			this.countyPicker.disable();
		}

		let sessionContactId = PJQ.app.session.contact ? PJQ.app.session.contact.id : null;
		if ((sessionContactId === this.options.contactId && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PREVENT_NATIONWIDE_WORK_AREAS_SUB)) || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PREVENT_NATIONWIDE_WORK_AREAS_PORTAL) || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PREVENT_NATIONWIDE_WORK_AREAS)) {
			this.$('.add-work-area-state-county').prop('disabled', !(stateWorkAreaId > 0));
		}
		else {
			this.$('.add-work-area-state-county').prop('disabled', !(_.size(country) > 0 || stateWorkAreaId > 0 || countyWorkAreaId > 0))
		}
	},
	addWorkAreaByStateCounty: function () {
		let country = this.countryPicker.getValue();
		if (_.size(country) === 0) {
			return;
		}

		let stateWorkAreaId = this.statePicker.getValue(),
			countyWorkAreaId = this.countyPicker.getValue(),
			self = this;
		if (stateWorkAreaId == null || _.size(stateWorkAreaId) === 0) {
			self.addNewWorkAreas(_.filter(self.states[country].models, function (workArea) {
				return _.indexOf((['hi', 'ak']), workArea.get('state').toLowerCase()) === -1;
			}));
		}
		else {
			let workArea = null,
				workAreaArray = [];
			if (_.size(stateWorkAreaId) === 1) {
				let stateWorkArea = this.states[country].get(stateWorkAreaId[0]);
				if (_.size(countyWorkAreaId) > 0) {
					_.each(countyWorkAreaId, function(id){
						if(id) {
							let countyWorkArea = this.counties[stateWorkArea.get('state')].get(id);
							workAreaArray.push(countyWorkArea);
						}
					}, this)
				}
				else {
					workArea = stateWorkArea;
				}
			}
			else if (_.size(stateWorkAreaId) > 1){
				_.each(stateWorkAreaId, function(id){
					if(id) {
						let stateWorkArea = this.states[country].get(id);
						workAreaArray.push(stateWorkArea);
					}
				}, this)
			}
			if(_.size(workAreaArray) > 0){
				this.addNewWorkAreas(workAreaArray)
			}
			else {
				this.addNewWorkAreas([workArea]);
			}
		}
	},
	addWorkAreasByZipRadius: function () {
		if (this.zipRadiusError != null) {
			this.zipRadiusError.destroy();
			this.zipRadiusError = null;
		}

		//Get all the work areas (counties) for the selected zip/radius
		let radius = this.$('.work-area-radius').val(),
			zip = PJQ.helpers.formatHelpers.formatZip(this.$('.work-area-zip').val()),
			newWorkAreas = new PJQ.collections.workAreas.WorkAreas([], {
				zip: zip,
				radius: radius
			});
		newWorkAreas.fetch({
			success: _.bind(function () {
				let newWorkAreaStateCount = _.size(_.uniq(_.map(newWorkAreas.models, function (newWorkArea) {
					return newWorkArea.get('state');
				})));
				newWorkAreas = new PJQ.collections.workAreas.WorkAreas(_.filter(newWorkAreas.models, _.bind(function (newWorkArea) {
					return this.collection.getExistingWorkArea(newWorkArea) == null;
				}, this)));
				if (_.size(newWorkAreas.models) > 0) {
					//If there are counties for more than 1 state in the result
					//Or the preference to always show the work area picker is enabled
					//Then show the work area picker
					if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_WORK_AREAS_ZIP_RADIUS_COUNTY_PICKER) || newWorkAreaStateCount > 1) {
						new PJQ.views.workAreas.SelectWorkAreasModal({
							collection: newWorkAreas,
							onSave: _.bind(function (selectedWorkAreas) {
								this.addNewWorkAreas(selectedWorkAreas, true);
							}, this)
						});
					}
					else {
						this.addNewWorkAreas(newWorkAreas.models, true);
					}
				}
				else {
					this.showZipRadiusError();
				}
			}, this)
		});
	},
	addNewWorkAreas: function (newWorkAreas, wasZipAdd = false) {
		let countiesChanged = false,
			statesChanged = false,
			newWorkAreasArray = [];
		_.each(newWorkAreas, function (newWorkArea) {
			let isStateWorkArea = newWorkArea.isStateWorkArea();
			if (isStateWorkArea) {
				let existingStateCountyWorkAreas = _.filter(this.collection.models, function (existingWorkArea) {
					return existingWorkArea.get('state') === newWorkArea.get('state') && !existingWorkArea.get('isDeleted');
				});
				_.each(existingStateCountyWorkAreas, _.bind(function (existingWorkArea) {
					this.deleteWorkArea(this.workAreaDataTable.getRow(existingWorkArea.cid));
					countiesChanged = true;
				}, this));
			}

			let existingWorkArea = this.collection.getExistingWorkArea(newWorkArea);
			if (existingWorkArea == null) {
				countiesChanged = newWorkArea.isCountyWorkArea() || countiesChanged;
				statesChanged = isStateWorkArea || statesChanged;

				let newContactWorkArea = new PJQ.models.workAreas.ContactWorkArea(_.defaults({contactId: this.options.contactId}, newWorkArea.toJSON()));
				this.collection.add(newContactWorkArea);
				this.onChange('add', newContactWorkArea);
				this.workAreaDataTable.addRow(newContactWorkArea);
				if (this.options.isSync) {
					newWorkAreasArray.push(newContactWorkArea);
				}
			}
			else if (existingWorkArea.get('isDeleted')) {
				existingWorkArea.set('isDeleted', false);
				this.onChange('add', existingWorkArea);
				this.workAreaDataTable.addRow(existingWorkArea);
			}
		}, this);
		if(this.options.isSync && _.size(newWorkAreasArray) > 0){
			let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.collection.options.contactId
				},
				{
					endpoint: 'workareas'
				},
				{
					endpoint: 'bulk'
				}
			]);
			new PJQ.ajax.Request({
				endpoint: endpoint,
				data: {
					workAreaIds: _.map(newWorkAreasArray, function (workArea) {
						return workArea.get('workAreaId')
					})
				}
			}).post().done(_.bind(function () {

			}, this)).fail(function () {
				PJQ.notifications.notify.errorNotify({
					message: 'Something went wrong!'
				});
			});
		}
		if (countiesChanged) {
			this.renderCountyLayers();
		}
		if (statesChanged) {
			this.renderStateLayers();
		}

		this.populateStateSelect();
		this.populateCountySelect();

		if (wasZipAdd) {
			this.resetZipEntry();
		}
	},
	showZipRadiusError: function () {
		this.zipRadiusError = new PJQ.Alert(this.$('.add-work-area-zip-button-container'), {
			type: 'danger',
			text: 'Unable to find new counties to add within the entered zip/radius',
			isPrepend: true,
			animation: {
				in: 'fadeIn'
			}
		});
	},
	deleteWorkAreaEvent: function (e) {
		let row = this.workAreaDataTable.getRow($(e.currentTarget).parents('tr')),
			workArea = row.data();
		this.deleteWorkArea(row);
		this.populateStateSelect();
		this.populateCountySelect();
		if (workArea.isStateWorkArea()) {
			this.renderStateLayers();
		}
		else if (workArea.isCountyWorkArea()) {
			this.renderCountyLayers();
		}
	},
	deleteAllWorkAreas: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: 'Are you sure you want to delete all work areas?',
			onDelete: _.bind(function () {
				_.each(_.clone(_.filter(this.collection.models, function (workArea) {
					return !workArea.get('isDeleted');
				})), _.bind(function (workArea) {
					this.deleteWorkArea(this.workAreaDataTable.getRow(workArea.cid));
				}, this));
				this.populateStateSelect();
				this.renderStateLayers();
				this.populateCountySelect();
				this.renderCountyLayers();
			}, this)
		});
	},
	deleteWorkArea: function (row) {
		let workArea = row.data();
		this.workAreaDataTable.removeRow(row);
		if (this.options.isSync || workArea.isNew()) {
			workArea.destroy();
		}
		else if (workArea.id > 0) {
			workArea.set('isDeleted', true);
		}
		this.onChange('delete', workArea);
		this.options.onDelete()
	},
	renderDeleteAllButtons: function () {
		this.$('.delete-all-work-areas').prop('disabled', _.size(this.collection.models) === 0);
	},
	resetZipEntry: function () {
		this.$('.work-area-zip').val('');
		this.setWorkAreaRadius(this.options.defaultRadius);
		this.workAreaZipInputChanged();
	},
	save: function (callback) {
		//This function is used when options.isSync == false
		//This is used by the code that constructs this view to save the work area data on some event outside the map (i.e. save contact in address book)
		//First delete the workareas that were deleted in the UI
		let newWorkAreas = _.filter(this.collection.models, function (model) {
				return model.isNew();
			}),
			deletedWorkAreas = this.collection.where({isDeleted: true});

		let addNewWorkAreas = _.bind(function() {
			if (_.size(newWorkAreas) > 0) {
				let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'contacts',
						value: this.collection.options.contactId
					},
					{
						endpoint: 'workareas'
					},
					{
						endpoint: 'bulk'
					}
				]);
				new PJQ.ajax.Request({
					endpoint: endpoint,
					data: {
						workAreaIds: _.map(newWorkAreas, function (workArea) {
							return workArea.get('workAreaId')
						})
					}
				}).post().done(_.bind(function () {
					if (typeof callback === 'function') {
						callback();
					}
				}, this)).fail(function () {
					PJQ.notifications.notify.errorNotify({
						message: 'Something went wrong!'
					});
				});
			}
			else if (typeof callback === 'function') {
				callback();
			}
		}, this);

		if (_.size(deletedWorkAreas) > 0) {
			let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.collection.options.contactId
				},
				{
					endpoint: 'workareas'
				},
				{
					endpoint: 'bulk'
				}
			]);
			new PJQ.ajax.Request({
				endpoint: endpoint,
				data: {
					workAreaIds: _.map(deletedWorkAreas, function (workArea) {
						return workArea.get('workAreaId')
					})
				}
			}).delete().done(_.bind(function () {
				if (_.size(newWorkAreas) > 0) {
					addNewWorkAreas();
				}
				else if (typeof callback === 'function') {
					callback();
				}
			}, this)).fail(function () {
				PJQ.notifications.notify.errorNotify({
					message: 'Something went wrong!'
				});
			});
		}
		else
		{
			addNewWorkAreas();
		}



	},
	onChange: function (e, data) {
		this.options.onChange({
			event: e,
			data: data,
			workAreas: this.collection
		});
	},
	showError: function (errorText) {
		this.hideError();
		this.errorAlert = new PJQ.Alert(this.$el, {
			type: 'danger',
			extraClasses: ['mt-1, mb-1'],
			text: errorText,
			isPrepend: true
		});
	},
	hideError: function () {
		if (this.errorAlert) {
			this.errorAlert.destroy();
		}
	}
});

PJQ.views.workAreas.WorkAreaMapModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Work-Area-Map'),
		minWidth: 800,
		isSync: false,
		isEdit: true,
		onSave: null
	},
	events: {
		"click .btn-save": "save"
	},
	afterRender: function () {
		this.workAreaMap = new PJQ.views.workAreas.WorkAreaMap({
			el: this.$('.map-outer'),
			collection: this.collection,
			isSync: this.options.isSync,
			isEdit: this.options.isEdit
		});
	},
	save: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave(this.workAreaMap.collection);
		}
		this.removeModal();
	}
});

PJQ.views.workAreas.SelectWorkAreasModal = PJQ.views.BaseModal.extend({
	defaults: {
		isSingleChoice: false,
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Work-Area-Select'),
		minWidth: 500,
		onSave: null
	},
	events: {
		"click .select-all-work-areas": "selectAllWorkAreas",
		"click .select-work-area": "selectWorkArea",
		"click .select-work-areas-save": "save"
	},
	beforeModalCreated: function () {
		this.selectedWorkAreas = [];
	},
	afterRender: function () {
		this.workAreasDataTable = new PJQ.views.dataTables.DataTable({
			el: this.$('.work-area-data-table'),
			data: this.collection.models,
			language: {
				emptyTable: "No work areas added",
				zeroRecords: "No work areas match the search criteria"
			},
			order: [[0, "asc"], [1, "asc"]],
			rowId: "cid",
			deferRender: true,
			columns: [
				{"data": "attributes.state", "title": "State"},
				{"data": "attributes.county", "title": "County"},
				{
					data: "attributes.isSelected",
					title: '<button type="button" class="btn btn-orange select-all-work-areas m-0a">Select All</button>',
					orderable: false,
					render: function (data) {
						return data ? '<button type="button" class="btn btn-secondary select-work-area wd-80p m-0a">Deselect</button>' : '<button type="button" class="btn btn-primary select-work-area wd-80p m-0a">Select</button>';
					}
				}
			],
			dom: '<"top"<"clear">p>rt<"bottom"p<"clear">>'
		});
	},
	selectAllWorkAreas: function () {
		this.selectedWorkAreas = this.collection.models;
		_.each(this.collection.models, function (model) {
			model.set('isSelected', true);
		});
		this.$('.select-work-area').text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
		this.selectWorkAreasChanged();
	},
	selectWorkArea: function (e) {
		let target = $(e.currentTarget),
			data = this.workAreasDataTable.getRow(target.parents('tr')).data();
		if (target.hasClass('btn-primary')) {
			target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
			this.selectedWorkAreas.push(data);
			data.set('isSelected', true);
		}
		else {
			target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
			this.selectedWorkAreas = _(this.selectedWorkAreas).filter(function (workArea) {
				return workArea.get('workAreaId') !== data.get('workAreaId');
			});
			data.set('isSelected', true);
		}
		this.selectWorkAreasChanged();
	},
	selectWorkAreasChanged: function () {
		this.$('.select-all-work-areas').prop('disabled', _.size(this.selectedWorkAreas) === _.size(this.collection.models));
		this.$('.select-work-areas-save').prop('disabled', _.size(this.selectedWorkAreas) === 0);
	},
	save: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave(this.selectedWorkAreas);
		}
	}
});
